import success from '@/assets/state/success.svg';
import error from '@/assets/state/error.svg';
import pending from '@/assets/state/pending.svg';

const paymentStatusFinalError = {
  text: 'canceled',
  color: '#e65639',
  icon: error,
  type: 'error',
  isFinal: true,
};
const paymentStatusFinalSucces = {
  text: 'success',
  icon: success,
  color: '#13c04c',
  type: 'success',
  isFinal: true,
};

const paymentStatusPending = {
  color: '#f3c924',
  icon: pending,
  text: 'pending',
  type: 'continuous',
  isFinal: false,
};

// Not map, but who cares 🤔
const statusesMap = {
  default: { ...paymentStatusPending, text: 'pending', icon: pending, isFinal: false },

  // Success statuses 💚
  revoked: { ...paymentStatusFinalSucces, text: 'revoked' },
  refunded: { ...paymentStatusFinalSucces, text: 'refunded' },
  authorized: { ...paymentStatusFinalSucces, text: 'authorized' },
  voided: { ...paymentStatusFinalSucces, text: 'voided' },
  charged_back: { ...paymentStatusFinalSucces, text: 'charged_back' },
  processed: { ...paymentStatusFinalSucces, text: 'processed' },
  partially_processed: { ...paymentStatusFinalSucces },

  // Pending statuses 💛
  invoke_pending: { ...paymentStatusPending },
  created: { ...paymentStatusPending },
  invoke_error: { ...paymentStatusPending },
  invoked: { ...paymentStatusPending },
  revoke_error: { ...paymentStatusPending },
  process_pending: { ...paymentStatusPending },
  process_error: { ...paymentStatusPending },
  refund_pending: { ...paymentStatusPending },

  // Error statuses 😡
  expired: { ...paymentStatusFinalError, text: 'expired' },
  terminated: { ...paymentStatusFinalError, text: 'terminated' },
  invoke_failed: { ...paymentStatusFinalError, text: 'invoke_failed' },
  revoke_failed: { ...paymentStatusFinalError, text: 'revoke_failed' },
  process_failed: { ...paymentStatusFinalError, text: 'process_failed' },
  refund_failed: { ...paymentStatusFinalError, text: 'refund_failed' },
};

export default statusesMap;
